import imageActions from './image';

export default {
  ...imageActions,
};
